import React, { useState, useEffect, useCallback, useContext } from 'react'
import '../css/sb-admin-2.min.css'
import '../css/sb-admin-2.css'
import DatePicker, { CalendarContainer } from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import { AppColors } from '../css/AppColors';
import { Modal, Button } from 'react-bootstrap';
import { apiRequest } from '../utils/apiCalls';
import Sidebar from '../Components/Sidebar';
import Topbar from '../Components/Topbar';
import { Context } from '../Context/DataContext';
import { useHistory, useLocation } from 'react-router';
import BackButton from '../Components/BackButton';
// import { reactLocalStorage } from 'reactjs-localstorage';



const useForceUpdate = () => {
    const [, updateState] = React.useState();
    return useCallback(() => updateState({}), []);
}



const ViewSingleCust = () => {


    const forceUpdate = useForceUpdate()
    const history = useHistory();
    const location = useLocation();
    const [startDate, setStartDate] = useState(new Date());

    const { state } = useContext(Context)

    const [selectedDate, setSelectedDate] = useState(new Date())
    const [loading, setLoading] = useState(false)

    const {
        cust_fname,
        cust_lname,
        cust_dob,
        cust_phone,
        cust_email,
        cust_address,
        cust_best_contact,
        h_phone,
    } = location?.state



    const [userData, setUserData] = useState({
        cust_fname: cust_fname,
        cust_lname: cust_lname,
        cust_dob: cust_dob,
        cust_phone: cust_phone,
        cust_email: cust_email,
        cust_address: cust_address,
        cust_best_contact: cust_best_contact,
        h_phone: h_phone ? h_phone : '',
    })





    return (
        <div id="page-top">
            <div id="wrapper" >
                <Sidebar />
                <div id="content-wrapper" class="d-flex flex-column">
                    <div id="content">
                        <Topbar />


                        <div className="container-fluid" >


                            <Modal
                                show={loading}
                                onHide={() => setLoading(false)}
                            >

                                <Modal.Body class="text-center" >
                                    <div
                                        class="text-center"
                                        class="spinner-border text-center" style={{ margin: 10, color: AppColors.primary }} role="status"></div>
                                </Modal.Body>

                            </Modal>
                            {/* Page Wrapper */}
                            <div id="wrapper" >
                                {/* Content Wrapper */}
                                <div id="content-wrapper" className="d-flex flex-column" style={{ paddingBottom: 200 }} >
                                    {/* Main Content */}
                                    <div id="content">
                                        {/* Begin Page Content */}
                                        <div className="container-fluid">
                                            {/* Page Heading */}
                                            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                                                <h1 className="h3 mb-0 text-gray-800">View Customer</h1>
                                            </div>
                                            <div className="row">
                                                {/* <form id="frm_customer"> */}
                                                <input
                                                    type="hidden"
                                                    name="g_name"
                                                    className="form-control form-control-user"
                                                    placeholder="From - Garage name"
                                                />
                                                <input
                                                    type="hidden"
                                                    name="g_phone"
                                                    className="form-control form-control-user"
                                                    placeholder="From - Garage phone"
                                                />
                                                <input
                                                    type="hidden"
                                                    name="g_email"
                                                    className="form-control form-control-user"
                                                    placeholder="From - Garage email"
                                                />
                                                <div className="form-group row">
                                                    <div className="col-sm-6">
                                                        <div className="editDetails" >First Name</div>
                                                        <input
                                                            type="text"
                                                            name="cust_fname"
                                                            id="cust_fname"
                                                            className="form-control form-control-user"
                                                            placeholder="First Name"
                                                            value={userData.cust_fname}
                                                            disabled={true}

                                                        />
                                                        <br />
                                                    </div>
                                                    <div className="col-sm-6 mb-3 mb-sm-0">
                                                        <div className="editDetails" >Last Name</div>
                                                        <input
                                                            type="text"
                                                            name="cust_lname"
                                                            id="cust_lname"
                                                            className="form-control form-control-user"
                                                            placeholder="Last Name"
                                                            value={userData.cust_lname}
                                                            disabled={true}
                                                        />
                                                        <br />
                                                    </div>
                                                    <div
                                                        className="col-sm-6 mb-3 mb-sm-0"
                                                    >
                                                        <div className="editDetails" >DOB</div>
                                                        <DatePicker
                                                            className="form-control form-control-user"
                                                            forma
                                                            // calendarContainer={MyContainer}
                                                            // showTimeSelect={true}
                                                            // dateFormat="Pp"
                                                            selected={cust_dob}
                                                            value={userData.cust_dob}
                                                            disabled={true}
                                                        />
                                                        {/* <input name="cust_dob" id="cust_dob" placeholder="DOB" /> */}
                                                        <br />
                                                    </div>
                                                    <div id="div_own_phone" className="col-sm-6 mb-3 mb-sm-0">
                                                        <div className="editDetails" >C-Phone</div>
                                                        <input
                                                            type="text"
                                                            name="cust_email"
                                                            id="cust_email"
                                                            className="form-control form-control-user"
                                                            placeholder="Email"
                                                            value={userData.cust_phone}
                                                            disabled={true}

                                                        />
                                                        <br />
                                                    </div>
                                                    <div id="div_own_email" className="col-sm-6 mb-3 mb-sm-0">
                                                        <div className="editDetails" >H-Phone</div>
                                                        <input
                                                            type="number"
                                                            name="H-Phone"
                                                            id="H-Phone"
                                                            className="form-control form-control-user"
                                                            placeholder="H-Phone"
                                                            value={userData.h_phone}
                                                            disabled={true}
                                                        />
                                                        <br />
                                                    </div>
                                                    <div id="div_own_email" className="col-sm-6 mb-3 mb-sm-0">
                                                        <div className="editDetails" >Email</div>
                                                        <input
                                                            type="text"
                                                            name="cust_phone"
                                                            id="cust_phone"
                                                            className="form-control form-control-user"
                                                            placeholder="C-Phone"
                                                            value={userData.cust_email}
                                                            
                                                            disabled={true}

                                                        />
                                                        <br />
                                                    </div>

                                                    <div className="col-sm-6 mb-3 mb-sm-0">
                                                        <div className="editDetails" >Address</div>
                                                        <input
                                                            type="text"
                                                            name="cust_address"
                                                            id="cust_address"
                                                            className="form-control form-control-user"
                                                            placeholder="Address"
                                                            value={userData.cust_address}
                                                            disabled={true}

                                                        />
                                                        <br />
                                                    </div>
                                                    <div className="col-sm-6 mb-3 mb-sm-0">
                                                        <div className="editDetails" >Best Contact</div>

                                                        <input
                                                            type="text"
                                                            name="cust_address"
                                                            id="cust_address"
                                                            className="form-control form-control-user"
                                                            placeholder="Best Contact"
                                                            value={userData.cust_best_contact}
                                                            disabled={true}

                                                        />
                                                        <br />
                                                    </div>
                                                  <BackButton/>


                                                </div>
                                                {/* </form> */}
                                            </div>
                                        </div>
                                        {/* /.container-fluid */}
                                    </div>
                                    {/* End of Main Content */}
                                </div>
                                {/* End of Content Wrapper */}
                            </div>
                            {/* End of Page Wrapper */}
                            {/* Scroll to Top Button*/}


                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ViewSingleCust
